import { render } from "./VoluntaryEntryDeleteAgree.vue?vue&type=template&id=2ed722c6"
import script from "./VoluntaryEntryDeleteAgree.vue?vue&type=script&lang=js"
export * from "./VoluntaryEntryDeleteAgree.vue?vue&type=script&lang=js"

import exportComponent from "/home/milu/Projects/tesco-csapatnap/csapatnap.hu-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__